// @need-translate
import {MouseEventHandler} from 'react';
import {ErrorArea} from '../ErrorArea/ErrorArea';

export function ContentNotSale({
  onClickGoToHome,
  isMobile,
}: {
  onClickGoToHome: MouseEventHandler;
  isMobile: boolean;
}) {
  return (
    <ErrorArea isMobile={isMobile}>
      <ErrorArea.Title>
        판매 중이 아닌 작품과 회차는
        <br />
        이용하실 수 없습니다
      </ErrorArea.Title>
      <ErrorArea.LabelButton onClick={onClickGoToHome}>
        홈으로 가기
      </ErrorArea.LabelButton>
    </ErrorArea>
  );
}
